// import React, { useContext } from "react";
// import Header from "../Components/Header";
// import Rightcontainer from "../Components/Rightcontainer";
// import { Link } from "react-router-dom";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";

// const Support = ({ handleShow }) => {
//   const theme = localStorage.getItem('theme')

//   // language 
//   const translations = {
//     hi: {
//       contact: 'नीचे दिए गए प्लेटफ़ॉर्म पर हमसे संपर्क करें।',
//       money: 'राशि डालें  ',
//       next: 'आगे बड़े ',
//       addAmount: 'राशि जोड़ी जानी है ',
//       referPerson: 'रेफ़रल | ',
//     },
//     en: {
//       contact: 'Contact Us At Below Platforms.',
//       money: 'Enter Amount',
//       next: 'Next',
//       addAmount: 'Amount to be added',
//       referPerson: 'Referral',
//     },
//   };

//   const { language } = useContext(LanguageContext);


//   // change theme 
//   const styles = {
//     backgroundColor: theme === 'light' ? '#d3e3fd' : 'black',
//     color: theme === 'light' ? 'black' : '#fff',
//   };
//   const styles1 = {
//     color: theme === 'light' ? 'black' : 'white',
//   };

//   return (
//     <div>
//       <div
//         className="leftContainer pt-5 mt-5"
//         style={styles}
//       >
//         <div className="supportNewLayout">

//           {/* TOP INFO CARD */}
//           <div className="helpTopCard">
//             <div className="helpLeftBar"></div>

//             <div className="helpContent">
//               <img src="./images/support.jpg" className="helpImg" />
//               <div>
//                 <h2 className="helpTitle">Need Help?</h2>
//                 <p className="helpSub">We are here for you 24/7</p>
//               </div>
//             </div>
//           </div>

//           {/* SUPPORT GRID */}
//           <div className="supportOptionGrid">

//             {/* Teligram */}
//             <a className="supportOptionCard" href={JSON.parse(localStorage.getItem("sitSetting")).supportTelegram}>
//               <div className="supportIcon emailBG">
//                 <img src="./images/telegram.png" alt="" />
//               </div>
//               <div className="supportText">
//                 <h5>Telegram Support</h5>
//                 <span>Expect a quick response</span>
//               </div>
//             </a>

//             {/* WhatsApp */}
//             {JSON.parse(localStorage.getItem("sitSetting"))?.whatsappSupport && (
//               <a
//                 className="supportOptionCard"
//                 target="_blank"
//                 href={JSON.parse(localStorage.getItem("sitSetting")).whatsappSupport}
//               >
//                 <div className="supportIcon">
//                   <img src="/images/whatsapp-new-.png" alt="" />
//                 </div>
//                 <div className="supportText">
//                   <h5>WhatsApp</h5>
//                   <span>Chat with us instantly</span>
//                 </div>
//               </a>
//             )}




//           </div>

//           {/* Email */}
//           {/* <a className="supportOptionCard" href="mailto:support@gmail.com">
//               <div className="supportIcon emailBG">
//                 <img src="./images/mail-new.png" alt="" />
//               </div>
//               <div className="supportText">
//                 <h5>Email Support</h5>
//                 <span>Expect a quick response</span>
//               </div>
//             </a> */}

//           {/* PHONE SUPPORT */}
//           {/* <div className="phone-banner">

//             <div className="phone-anim">
//               <img src="/images/phone.png" alt="" />
//             </div>

//             <div className="phone-content">
//               <span>Need direct help?</span>
//               <h4 style={{ margin: 0, fontWeight: 700 }}>Phone Support</h4>

//               <a
//                 className="phone-number"
//                 href={
//                   "tel:" +
//                   JSON.parse(localStorage.getItem("sitSetting"))?.CompanyMobile
//                 }
//                 target="_blank"
//               >
//                 {JSON.parse(localStorage.getItem("sitSetting"))?.CompanyMobile}
//               </a>
//             </div>

//             <a
//               href={
//                 "tel:" +
//                 JSON.parse(localStorage.getItem("sitSetting"))?.CompanyMobile
//               }
//               className="call-btn"
//             >
//               Call Now
//             </a>

//           </div> */}

//         </div>

//       </div>
//       <div className="rightContainer">
//         <Rightcontainer />
//       </div>
//     </div>
//   );
// };

// export default Support;
import React, { useContext } from "react";
import Rightcontainer from "../Components/Rightcontainer";
import { LanguageContext } from "../Components/LanguageContext";

import {
  FaHeadset,
  FaTelegramPlane,
  FaWhatsapp,
  FaShieldAlt,
  FaClock,
  FaArrowRight,
  FaCheckCircle,
  FaStar
} from "react-icons/fa";

const Support = () => {
  const { language } = useContext(LanguageContext);

  const siteSetting =
    JSON.parse(localStorage.getItem("sitSetting")) || {};

  const translations = {
    hi: {
      help: "सपोर्ट सेंटर",
      sub: "हम आपकी सहायता के लिए 24x7 यहां हैं",
      team: "हमारी सहायता टीम",
      replies: "आमतौर पर 2 मिनट में उत्तर देता है",
      telegram: "Telegram Support",
      official: "Official Channel",
      contact: "Contact Us",
      voice: "Voice Assistance",
      secure: "SECURE & VERIFIED SUPPORT",
      available: "हमेशा उपलब्ध",
      chat: "अभी चैट करें",
      trusted: "Trusted Support"
    },

    en: {
      help: "SUPPORT CENTER",
      sub: "We are available 24x7 to help you",
      team: "Our Support Team",
      replies: "Typically replies in 2 mins",
      telegram: "Telegram Support",
      official: "Official Channel",
      contact: "Contact Us",
      voice: "Voice Assistance",
      secure: "SECURE & VERIFIED SUPPORT",
      available: "Always Available",
      chat: "Chat Now",
      trusted: "Trusted Support"
    }
  };

  const t = translations[language] || translations.en;

  return (
    <div className="prince_support_page">

      <div className="prince_support_main">

        {/* =========================================
            HERO
        ========================================== */}

        <section className="prince_support_hero">

          <div className="prince_support_glow prince_glow_one"></div>
          <div className="prince_support_glow prince_glow_two"></div>

          <div className="prince_support_crown">
            <FaStar />
          </div>

          <div className="prince_support_hero_content">

            <div className="prince_support_icon_3d">

              <div className="prince_support_icon_inner">
                <FaHeadset />
              </div>

              <span className="prince_support_icon_shine"></span>

            </div>

            <div className="prince_support_heading">

              <span className="prince_support_overline">
                PRINCE LUDO
              </span>

              <h1>
                SUPPORT <strong>CENTER</strong>
              </h1>

              <p>
                {t.sub}
              </p>

            </div>

          </div>


          <div className="prince_support_available">

            <span className="prince_live_dot"></span>

            <div>
              <strong>24/7</strong>
              <small>{t.available}</small>
            </div>

          </div>


          <div className="prince_support_hero_bottom">

            <span></span>

            <div>
              <FaCheckCircle />
              {t.trusted}
            </div>

            <span></span>

          </div>

        </section>


        {/* =========================================
            TEAM CARD
        ========================================== */}

        <section className="prince_support_team">

          <div className="prince_team_avatar_3d">

            <div className="prince_team_avatar">

              <FaHeadset />

            </div>

            <span className="prince_avatar_online"></span>

          </div>


          <div className="prince_team_details">

            <div className="prince_team_title">

              <h2>
                {t.team}
              </h2>

              <span>
                <FaCheckCircle />
              </span>

            </div>

            <p>
              {t.replies}
            </p>

          </div>


          <div className="prince_team_time">

            <FaClock />

            <span>
              24/7
            </span>

          </div>

        </section>


        {/* =========================================
            SUPPORT OPTIONS
        ========================================== */}

        <div className="prince_support_label">

          <span>
            CHOOSE YOUR SUPPORT
          </span>

          <i>✦</i>

        </div>


        <section className="prince_support_options">

          {/* TELEGRAM */}

          {siteSetting.supportTelegram && (

            <a
              href={siteSetting.supportTelegram}
              className="prince_support_option prince_telegram_option"
              target="_blank"
              rel="noreferrer"
            >

              <div className="prince_option_top">

                <div className="prince_option_icon">

                  <FaTelegramPlane />

                </div>

                <div className="prince_option_badge">
                  OFFICIAL
                </div>

              </div>


              <div className="prince_option_content">

                <h3>
                  {t.telegram}
                </h3>

                <p>
                  {t.official}
                </p>

              </div>


              <div className="prince_option_bottom">

                <span>
                  {t.chat}
                </span>

                <div className="prince_option_arrow">
                  <FaArrowRight />
                </div>

              </div>


              <div className="prince_option_3d">
                ✈
              </div>

            </a>

          )}


          {/* WHATSAPP */}

          {siteSetting.whatsappSupport && (

            <a
              href={siteSetting.whatsappSupport}
              className="prince_support_option prince_whatsapp_option"
              target="_blank"
              rel="noreferrer"
            >

              <div className="prince_option_top">

                <div className="prince_option_icon">

                  <FaWhatsapp />

                </div>

                <div className="prince_option_badge">
                  LIVE
                </div>

              </div>


              <div className="prince_option_content">

                <h3>
                  {t.contact}
                </h3>

                <p>
                  {t.voice}
                </p>

              </div>


              <div className="prince_option_bottom">

                <span>
                  {t.chat}
                </span>

                <div className="prince_option_arrow">
                  <FaArrowRight />
                </div>

              </div>


              <div className="prince_option_3d">
                ☎
              </div>

            </a>

          )}

        </section>


        {/* =========================================
            SECURITY STRIP
        ========================================== */}

        <section className="prince_support_security">

          <div className="prince_security_icon">
            <FaShieldAlt />
          </div>

          <div className="prince_security_text">

            <strong>
              {t.secure}
            </strong>

            <span>
              Your privacy and safety are always our priority.
            </span>

          </div>

          <div className="prince_security_check">
            <FaCheckCircle />
          </div>

        </section>


        {/* =========================================
            FOOTER
        ========================================== */}

        <div className="prince_support_footer">

          <span></span>

          <div>
            <FaStar />
            PRINCE LUDO
            <FaStar />
          </div>

          <span></span>

        </div>

      </div>


      {/* RIGHT CONTAINER */}

      <div className="rightContainer hidden-mobile">
        <Rightcontainer />
      </div>

    </div>
  );
};

export default Support;